import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=714b37d5&scoped=true"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=714b37d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714b37d5",
  null
  
)

export default component.exports